export default {
  path: '/subscription-imports/:id',
  name: 'subscription-import',
  component: () => import(/* webpackChunkName: "imported-subscription" */ './ImportedSubscription'),
  props: true,
  meta: { requiresAuth: true }
}
